import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
} from '@mui/material';
import { forwardRef } from 'react';

type Props = Pick<
  MuiCheckboxProps,
  | 'checked'
  | 'defaultChecked'
  | 'disabled'
  | 'onChange'
  | 'size'
  | 'name'
  | 'id'
  | 'required'
  | 'value'
  | 'slotProps'
  | 'className'
  | 'sx'
  | 'indeterminate'
  | 'onClick'
> & {
  label?: React.ReactNode;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  testId?: string;
};

const Checkbox = forwardRef<HTMLButtonElement, Props>(
  (
    {
      label,
      labelPlacement = 'end',
      checked,
      defaultChecked,
      disabled,
      size,
      name,
      id,
      required,
      value,
      slotProps,
      indeterminate,
      className,
      sx,
      testId,
      onChange,
      onClick,
    },
    ref,
  ) => {
    const muiProps = {
      'test-id': testId,
      checked,
      defaultChecked,
      disabled,
      size,
      name,
      id,
      required,
      value,
      slotProps,
      indeterminate,
      className,
      sx,
      onChange,
      onClick,
    };

    if (label !== undefined) {
      return (
        <FormControlLabel
          control={<MuiCheckbox {...muiProps} ref={ref} />}
          label={label}
          labelPlacement={labelPlacement}
          className={className}
          sx={sx}
        />
      );
    }

    return <MuiCheckbox {...muiProps} ref={ref} />;
  },
);

Checkbox.displayName = 'Checkbox';
export type { Props as CheckboxProps };
export default Checkbox;
